import React, { useState } from 'react'
import { Typography, Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import useRouter from 'utils/useRouter'
import { BaseCard, CardField } from 'components'

const useStyles = makeStyles((theme) => ({
  badgePendente: {
    ...theme.typography.caption,
    fontSize: '0.75rem',
    color: '#fb6944',
    fontWeight: 600,
    marginTop: '2px',
    display: 'block',
  },
  headerTitle: {
    display: 'flex',
    flexDirection: 'column',
  },
}))

export const CardExameSolicitado = (props) => {
  const classes = useStyles()
  const { exameSolicitado, handleClick, aninhado } = props
  const router = useRouter()
  const [anchorElMenu, setAnchorElMenu] = useState(null)

  const handleClickBotaoAcoes = (event) => {
    event.stopPropagation()
    setAnchorElMenu(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorElMenu(null)
  }

  const renderTitle = () => (
    <div className={classes.headerTitle}>
      <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
        {exameSolicitado.tipoEx?.nome}
      </Typography>
      {exameSolicitado.pendenteConfirmacao && (
        <span className={classes.badgePendente}>Pendente de confirmação</span>
      )}
    </div>
  )

  const renderAction = () => {
    if (exameSolicitado.pendenteConfirmacao) {
      return (
        <IconButton aria-label="settings" onClick={handleClickBotaoAcoes}>
          <MoreVertIcon />
        </IconButton>
      )
    }
    return null
  }

  return (
    exameSolicitado ? (
      <BaseCard
        avatar="EXAME"
        title={renderTitle()}
        action={renderAction()}
        aninhado={aninhado}
        onClick={() => {
          if (!exameSolicitado.pendenteConfirmacao) {
            handleClick(exameSolicitado.id)
          }
        }}
        onNovaAba={() => handleClick(exameSolicitado.id, true)}
      >
        <CardField label="Número do exame" value={exameSolicitado.exReal?.numeroExame} />
        <CardField label="Status" value={exameSolicitado.exReal?.status || 'Pendente'} />
        <CardField label="Setor responsável" value={exameSolicitado.setor?.nome} />
        <CardField
          label="Examinadores"
          value={
            exameSolicitado.exReal?.usuExams?.length
              ? exameSolicitado.exReal.usuExams.map((item) => item.nome).join(', ')
              : 'Não atribuído'
          }
        />

        {exameSolicitado.pendenteConfirmacao && (
          <Menu
            id="menu-acoes-confirmar-exame"
            anchorEl={anchorElMenu}
            open={Boolean(anchorElMenu)}
            onClose={handleCloseMenu}
            keepMounted
          >
            <MenuItem onClick={() => router.history.push(`/solicitacao/exame/confirmar/${exameSolicitado.id}`)}>
              <ListItemIcon>
                <CheckCircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Confirmar exame" />
            </MenuItem>
          </Menu>
        )}
      </BaseCard>
    ) : null
  )
}
